import functionWrap from 'ming-ui/components/FunctionWrap';
import ImportFileToChildTable from './ImportFileToChildTable';

export const importFileToChildTable = props => functionWrap(ImportFileToChildTable, props);
